import { useEffect } from 'react'

interface ToastProps {
  message: string
  visible: boolean
  onHide: () => void
}

export function Toast({ message, visible, onHide }: ToastProps) {
  useEffect(() => {
    if (!visible) return
    const t = setTimeout(onHide, 3000)
    return () => clearTimeout(t)
  }, [visible, onHide])

  return (
    <>
      <div
        className={`v2-toast${visible ? ' show' : ''}`}
        role="status"
        aria-live="polite"
      >
        <div className="v2-toast-dot" />
        {message}
      </div>
    </>
  )
}
